<template>
  <BlockTheme :theme="theme?.contentBlocks">
    <slot />
  </BlockTheme>
</template>

<script lang="ts" setup>
import type { ContentGridTheme } from '~/sanity/types';
import BlockTheme from './BlockTheme.vue';
defineProps<{ theme?: ContentGridTheme }>();
</script>

<style></style>
